import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white shadow-md" data-id="element-300">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col md:flex-row items-center justify-center md:justify-between gap-2 md:gap-4" data-id="element-301">
        <p className="text-sm md:text-base font-bold uppercase tracking-wide text-center" data-id="element-302">
          ⚡ Questa offerta scade presto
        </p>
        <CountdownTimer variant="light" className="scale-75 md:scale-90 origin-center" data-id="element-303" />
      </div>
    </div>;
}